module.exports = __webpack_public_path__ + "static/marchi-panorama-067c610206c31b6bc96806e730aa720a.jpg";